import React, { useState } from 'react';
import validator from 'validator';
import { makeStyles } from '@mui/styles';
import { Check, Clear, Schedule } from '@mui/icons-material';
import {
  Fade,
  Modal,
  Paper,
  Box,
  Backdrop,
  Theme,
  Typography,
  IconButton,
  TextField,
  Button,
  Grid,
} from '@mui/material';

import { CustomButton } from '@buttons/CustomButton';

type ModalHelpProps = {
  onClose: () => void;
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    [theme.breakpoints.down('sm')]: {
      width: '90%',
    },
    top: '50%',
    left: '50%',
    width: 420,
    borderRadius: 8,
    position: 'absolute',
    transform: 'translate(-50%, -50%)',
  },
}));

export const ModalHelp: React.FC<ModalHelpProps> = ({ onClose }) => {
  const classes = useStyles();
  const [end, setEnd] = useState<string>('');
  const [start, setStart] = useState<string>('');
  const [phone, setPhone] = useState<string>('');

  const isValidTime = (value: string): boolean => {
    const isValid = /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/.test(
      value
    );
    if (isValid) {
      return true;
    }
    return false;
  };

  const isValidForm = (): boolean => {
    if (!validator.isMobilePhone(phone)) {
      return false;
    } else if (phone.length !== 10) {
      return false;
    } else if (!isValidTime(start)) {
      return false;
    } else if (!isValidTime(end)) {
      return false;
    }
    return true;
  };

  return (
    <Modal
      open
      onClose={onClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in>
        <Paper className={classes.root}>
          <Box padding={2}>
            <Box
              marginBottom={2}
              display={'flex'}
              flexDirection={'row'}
              justifyContent={'space-between'}
              alignItems={'center'}
            >
              <Typography variant={'h6'} fontWeight={'bold'}>
                {'¿No encuentras tu vehículo?'}
              </Typography>
              <IconButton onClick={onClose}>
                <Clear />
              </IconButton>
            </Box>
            <Typography
              marginBottom={2}
              fontWeight={'700'}
              textAlign={'center'}
              variant={'subtitle2'}
            >
              {'Llámanos '}
            </Typography>
            <Typography
              marginBottom={1}
              fontWeight={'400'}
              textAlign={'center'}
              variant={'body2'}
            >
              {'Uno de nuestros asesores te atenderá: '}
            </Typography>
            <Box display={'flex'} justifyContent={'center'} marginBottom={2}>
              <Button
                onClick={() => null}
                variant={'text'}
                color={'primary'}
                style={{
                  padding: 0,
                  fontSize: 14,
                  fontWeight: 400,
                  textTransform: 'none',

                  textDecoration: 'underline',
                }}
              >
                {'800-123-5678'}
              </Button>
            </Box>
            <Typography
              marginBottom={1}
              fontWeight={'700'}
              textAlign={'center'}
              variant={'body2'}
            >
              {'Ó'}
            </Typography>
            <Typography
              marginBottom={2}
              fontWeight={'700'}
              textAlign={'center'}
              variant={'body2'}
            >
              {'¿Prefieres que te llamemos?'}
            </Typography>
            <Box marginBottom={2}>
              <TextField
                fullWidth
                value={phone}
                variant="outlined"
                label="Teléfono"
                style={{ borderRadius: '8px' }}
                color={
                  validator.isMobilePhone(phone) && phone.length === 10
                    ? 'success'
                    : 'primary'
                }
                onChange={(e) => setPhone(e.target.value)}
                InputProps={{
                  style: {
                    borderRadius: 8,
                  },
                  endAdornment:
                    validator.isMobilePhone(phone) && phone.length === 10 ? (
                      <Check color={'success'} />
                    ) : null,
                }}
              />
            </Box>
            <Typography marginBottom={2.4} variant={'subtitle2'}>
              {'Elige el horario para que podamos llamarte'}
            </Typography>
            <Grid container marginBottom={2.8} spacing={{ xs: 2, md: 3 }}>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  value={start}
                  variant="outlined"
                  label="De:"
                  color={isValidTime(start) ? 'success' : 'primary'}
                  onChange={(e) => setStart(e.target.value)}
                  InputProps={{
                    style: {
                      borderRadius: 8,
                    },
                    endAdornment: (
                      <Schedule
                        color={isValidTime(start) ? 'success' : 'inherit'}
                      />
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  value={end}
                  variant="outlined"
                  label="A:"
                  color={isValidTime(end) ? 'success' : 'primary'}
                  onChange={(e) => setEnd(e.target.value)}
                  InputProps={{
                    style: {
                      borderRadius: 8,
                    },
                    endAdornment: (
                      <Schedule
                        color={isValidTime(end) ? 'success' : 'inherit'}
                      />
                    ),
                  }}
                />
              </Grid>
            </Grid>
            <CustomButton
              text={'Enviar'}
              onClick={onClose}
              color={'primary'}
              variant={'contained'}
              disabled={!isValidForm()}
              style={{ height: 56, width: '100%', textTransform: 'none' }}
            />
          </Box>
        </Paper>
      </Fade>
    </Modal>
  );
};
